module.exports = __webpack_public_path__ + "img/0Q3A8493_L_Foamcore.bb50cd1d.jpg";